import { render, staticRenderFns } from "./BannerHBF.vue?vue&type=template&id=9bc34a68&scoped=true"
import script from "./BannerHBF.vue?vue&type=script&lang=js"
export * from "./BannerHBF.vue?vue&type=script&lang=js"
import style0 from "./BannerHBF.vue?vue&type=style&index=0&id=9bc34a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc34a68",
  null
  
)

export default component.exports